import { FC, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Collapse, Text } from '@blueprintjs/core'
import cn from 'classnames'
import { Dot } from 'client/components/Trans/components/Dot/Dot'
import { Trans } from 'client/components/Trans/Trans'
import Chevron from 'images/chevron.png'
import { ClientLocaleNS } from 'lib/constants/locales'
import { useClickOutside } from 'lib/hooks/useClickOutside'

type TProps = {
  listIndex: number
  index: number
}

const PSListItem: FC<TProps> = ({ listIndex, index }) => {
  const ref = useRef<HTMLLIElement>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation(ClientLocaleNS.PartnerSupportPage)

  useClickOutside([ref], () => {
    if (isOpen) {
      setIsOpen(false)
    }
  })

  return (
    <li ref={ref} className="flex w-full flex-col border-b border-solid border-border-primary">
      <div
        className="flex w-full cursor-pointer items-center justify-between gap-8 py-8 lg:py-12"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text tagName="span" className="font-primary-bold---17pt text-text-black">
          {t(`faq_block.lists.${listIndex + 1}.items.${index + 1}.title`)}
        </Text>
        <div className="flex">
          <img src={Chevron} className={cn('w-6 object-contain transition-all', isOpen && 'rotate-180')} />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="flex w-full pb-8 lg:w-8/12 lg:pb-12 lg:pr-0">
          <Text tagName="p" className="font-primary-regular---15pt w-full whitespace-pre-wrap text-text-black">
            <Trans
              i18nKey={`faq_block.lists.${listIndex + 1}.items.${index + 1}.caption`}
              ns={ClientLocaleNS.PartnerSupportPage}
              components={{ dot: <Dot /> }}
            />
          </Text>
        </div>
      </Collapse>
    </li>
  )
}

export { PSListItem }
